var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Color } from '../const';
import Tooltip from './tooltip';
import { BaseTooltipContainer, BaseTooltipArrow } from './util';
function ValidationTooltip(props) {
    return (React.createElement(Tooltip, __assign({}, props, { overlay: React.createElement("span", null, props.invalidMessage), CustomArrow: StyledArrow, CustomTooltipContainer: ToolTipContainer })));
}
var ToolTipContainer = styled(BaseTooltipContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: none;\n  color: ", ";\n  white-space: nowrap; /* NOTE \u4F4D\u7F6E\u8A08\u7B97\u304C\u3046\u307E\u304F\u3067\u304D\u306A\u3044\u305F\u3081\u306Eworkaround */\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: none;\n  color: ", ";\n  white-space: nowrap; /* NOTE \u4F4D\u7F6E\u8A08\u7B97\u304C\u3046\u307E\u304F\u3067\u304D\u306A\u3044\u305F\u3081\u306Eworkaround */\n"])), Color.VERY_PALE_RED, Color.SOFT_RED, Color.SOFT_RED);
var StyledArrow = styled(BaseTooltipArrow)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-left: none;\n  border-radius: 2px 0;\n  border-top: none;\n  box-shadow: none;\n  transform: rotate(45deg);\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-left: none;\n  border-radius: 2px 0;\n  border-top: none;\n  box-shadow: none;\n  transform: rotate(45deg);\n"])), Color.VERY_PALE_RED, Color.SOFT_RED);
export default ValidationTooltip;
var templateObject_1, templateObject_2;
//# sourceMappingURL=validation-tooltip.js.map